import { useState } from "react";
import { makeStyles } from "@mui/styles";
import { Grid2 as Grid, Container, Typography, TextField } from "@mui/material";
import { LargeActionButton } from "../../components/Common/LargeActionButton";

const useStyles = makeStyles((theme) => ({
	buttonContainer: {
		height: "245px",
		display: "flex",
		flexFlow: "column",
		justifyContent: "flex-end",
	},
}));

export default function AdhocCreditRequestInit(props) {
	const { onContinue } = props;
	const [poNumber, setPoNumber] = useState("");
	const [invNumber, setInvNumber] = useState("");
	const classes = useStyles();

	const handlePoNumberChange = (event) => {
		setPoNumber(event.target.value);
	};
	const handleInvNumberChange = (event) => {
		setInvNumber(event.target.value);
	};
	const handleContinueClick = () => {
		if (onContinue && poNumber) onContinue(poNumber, invNumber);
	};

	const canContinue = () => !!poNumber;
	return (
		<Container disableGutters maxWidth="md">
			<Grid container direction="column" justifyContent="center" spacing={2}>
				<Grid size="grow">
					<Typography variant="h6" component="div">
						New credit request
					</Typography>
					<Typography variant="body1" component="div">
						Raise a new credit request by providing the PO number, and invoice number if relevant
					</Typography>
				</Grid>
				<Grid size="grow">
					<TextField
						id="po-number"
						name="po-number"
						label="Purchase Order Number"
						variant="outlined"
						fullWidth
						required
						onChange={handlePoNumberChange}
					/>
				</Grid>
				<Grid size="grow">
					<TextField
						id="inv-number"
						name="inv-number"
						label="Invoice Number (optional)"
						variant="outlined"
						fullWidth
						onChange={handleInvNumberChange}
					/>
				</Grid>
			</Grid>
			<div className={classes.buttonContainer}>
				<LargeActionButton onClick={handleContinueClick} disabled={!canContinue()}>
					Continue
				</LargeActionButton>
			</div>
		</Container>
	);
}
